import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "p-fluid p-m-5",
  ref: "domain-form"
}
const _hoisted_2 = { class: "p-float-label" }
const _hoisted_3 = {
  for: "valueCd",
  class: "kn-material-input-label"
}
const _hoisted_4 = { class: "p-float-label" }
const _hoisted_5 = {
  for: "valueName",
  class: "kn-material-input-label"
}
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = {
  for: "domainCode",
  class: "kn-material-input-label"
}
const _hoisted_8 = { class: "p-float-label" }
const _hoisted_9 = {
  for: "domainName",
  class: "kn-material-input-label"
}
const _hoisted_10 = { class: "p-float-label" }
const _hoisted_11 = {
  for: "valueDescription",
  class: "kn-material-input-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: true,
    modal: true,
    class: "p-fluid kn-dialog--toolbar--primary",
    header: _ctx.formHeader,
    closable: false,
    style: _ctx.domainsManagementDescriptor.form.style
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--secondary",
        label: _ctx.$t('common.close'),
        onClick: _ctx.closeTemplate
      }, null, 8, ["label", "onClick"]),
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        label: _ctx.$t('common.save'),
        disabled: _ctx.buttonDisabled,
        onClick: _ctx.handleSubmit
      }, null, 8, ["label", "disabled", "onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode("form", _hoisted_1, [
        _createVNode("div", {
          class: "p-field",
          style: _ctx.domainsManagementDescriptor.pField.style
        }, [
          _createVNode("span", _hoisted_2, [
            _createVNode(_component_InputText, {
              id: "valueCd",
              class: ["kn-material-input", {
                            'p-invalid': _ctx.v$.domain.valueCd.$invalid && _ctx.v$.domain.valueCd.$dirty
                        }],
              type: "text",
              modelValue: _ctx.v$.domain.valueCd.$model,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.domain.valueCd.$model = $event)),
              modelModifiers: { trim: true },
              maxLength: "100",
              onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.domain.valueCd.$touch()))
            }, null, 8, ["modelValue", "class"]),
            _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('managers.domainsManagement.valueCode')) + " *", 1)
          ]),
          _createVNode(_component_KnValidationMessages, {
            vComp: _ctx.v$.domain.valueCd,
            additionalTranslateParams: { fieldName: _ctx.$t('managers.domainsManagement.valueCode') }
          }, null, 8, ["vComp", "additionalTranslateParams"])
        ], 4),
        _createVNode("div", {
          class: "p-field",
          style: _ctx.domainsManagementDescriptor.pField.style
        }, [
          _createVNode("span", _hoisted_4, [
            _createVNode(_component_InputText, {
              id: "valueName",
              class: ["kn-material-input", {
                            'p-invalid': _ctx.v$.domain.valueName.$invalid && _ctx.v$.domain.valueName.$dirty
                        }],
              type: "text",
              modelValue: _ctx.v$.domain.valueName.$model,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.v$.domain.valueName.$model = $event)),
              modelModifiers: { trim: true },
              maxLength: "40",
              onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.domain.valueName.$touch()))
            }, null, 8, ["modelValue", "class"]),
            _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('managers.domainsManagement.valueName')) + " * ", 1)
          ]),
          _createVNode(_component_KnValidationMessages, {
            vComp: _ctx.v$.domain.valueName,
            additionalTranslateParams: { fieldName: _ctx.$t('managers.domainsManagement.valueName') }
          }, null, 8, ["vComp", "additionalTranslateParams"])
        ], 4),
        _createVNode("div", {
          class: "p-field",
          style: _ctx.domainsManagementDescriptor.pField.style
        }, [
          _createVNode("span", _hoisted_6, [
            _createVNode(_component_InputText, {
              id: "domainCode",
              class: ["kn-material-input", {
                            'p-invalid': _ctx.v$.domain.domainCode.$invalid && _ctx.v$.domain.domainCode.$dirty
                        }],
              type: "text",
              modelValue: _ctx.v$.domain.domainCode.$model,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.v$.domain.domainCode.$model = $event)),
              modelModifiers: { trim: true },
              maxLength: "20",
              onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.v$.domain.domainCode.$touch()))
            }, null, 8, ["modelValue", "class"]),
            _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('managers.domainsManagement.domainCode')) + " * ", 1)
          ]),
          _createVNode(_component_KnValidationMessages, {
            vComp: _ctx.v$.domain.domainCode,
            additionalTranslateParams: { fieldName: _ctx.$t('managers.domainsManagement.domainCode') }
          }, null, 8, ["vComp", "additionalTranslateParams"])
        ], 4),
        _createVNode("div", {
          class: "p-field",
          style: _ctx.domainsManagementDescriptor.pField.style
        }, [
          _createVNode("span", _hoisted_8, [
            _createVNode(_component_InputText, {
              id: "domainName",
              class: ["kn-material-input", {
                            'p-invalid': _ctx.v$.domain.domainName.$invalid && _ctx.v$.domain.domainName.$dirty
                        }],
              type: "text",
              modelValue: _ctx.v$.domain.domainName.$model,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.v$.domain.domainName.$model = $event)),
              modelModifiers: { trim: true },
              maxLength: "40",
              onBlur: _cache[8] || (_cache[8] = ($event: any) => (_ctx.v$.domain.domainName.$touch()))
            }, null, 8, ["modelValue", "class"]),
            _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('managers.domainsManagement.domainName')) + " * ", 1)
          ]),
          _createVNode(_component_KnValidationMessages, {
            vComp: _ctx.v$.domain.domainName,
            additionalTranslateParams: { fieldName: _ctx.$t('managers.domainsManagement.domainName') }
          }, null, 8, ["vComp", "additionalTranslateParams"])
        ], 4),
        _createVNode("div", {
          class: "p-field",
          style: _ctx.domainsManagementDescriptor.pField.style
        }, [
          _createVNode("span", _hoisted_10, [
            _createVNode(_component_InputText, {
              id: "valueDescription",
              class: ["kn-material-input", {
                            'p-invalid': _ctx.v$.domain.valueDescription.$invalid && _ctx.v$.domain.valueDescription.$dirty
                        }],
              type: "text",
              modelValue: _ctx.v$.domain.valueDescription.$model,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.v$.domain.valueDescription.$model = $event)),
              modelModifiers: { trim: true },
              maxLength: "160",
              onBlur: _cache[10] || (_cache[10] = ($event: any) => (_ctx.v$.domain.valueDescription.$touch()))
            }, null, 8, ["modelValue", "class"]),
            _createVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('managers.domainsManagement.valueDescription')) + " * ", 1)
          ]),
          _createVNode(_component_KnValidationMessages, {
            vComp: _ctx.v$.domain.valueDescription,
            additionalTranslateParams: { fieldName: _ctx.$t('managers.domainsManagement.valueDescription') }
          }, null, 8, ["vComp", "additionalTranslateParams"])
        ], 4)
      ], 512)
    ]),
    _: 1
  }, 8, ["header", "style"]))
}